import { getters } from "./getters"
import { actions } from "./actions"
import { mutations } from "./mutations"

const state = () => ({
    indiceList: [],
    indicePerf: [],
    indiceRanking: [],
    indiceRankingReturn: [],
    indiceFollowing: [],
    indiceNav: [],
    indiceQuote: {},
    indiceNavShare: {
        "1D": {},
        "1M": {},
        "3M": {},
        "6M": {},
        "1Y": {}
    },
    indiceTimestamp1D: {
        from: "",
        to: ""
    }
})

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
